export type TrackingStatusNotice = 'toTreat' | 'exportFailed' | 'error'

/**
 * Statut Dossiers (`batch_import_log_status`) d'une notification `tracking_status`. La gateway
 * n'émet qu'à l'entrée dans l'un de ces trois états (SEGMENTED / MAPPED seulement avec un export) :
 * voir `emitTrackingStatusNotificationPg` dans nabu-backend.
 */
export const mapTrackingStatusNotice = (
  status: string | null | undefined
): TrackingStatusNotice | null => {
  switch ((status ?? '').toUpperCase()) {
    case 'SEGMENTED':
    case 'MAPPED':
      return 'toTreat'
    case 'EXPORT_FAILED':
      return 'exportFailed'
    case 'FAILED':
      return 'error'
    default:
      return null
  }
}
